import {useRoute} from '@react-navigation/core';
import {
  Alert,
  BottomSheetDialog,
  Div,
  Dropdown,
  HeaderBack,
  InputItem,
  Label,
  Toast,
} from 'components';
import {Ecolors, stringApp} from 'constant';
import React, {useEffect, useRef, useState} from 'react';
import {Platform} from 'react-native';
import {ScrollView} from 'react-native-gesture-handler';
import {useDispatch} from 'react-redux';
import {getInfo} from 'reducer/authen';
import {getStatusEditBankInfo} from 'reducer/authen/selector';
import ComActionUpload from 'screens/MainScreen/DigitalSignature/ComActionUpload';
import {apiAuth, goBack, navigate} from 'services';
import {doGetAxios} from 'services/apis/axios';
import {useAppDispatch, useAppSelector} from 'store/hooks';
import {
  checkToSetNumber,
  getImageCamera,
  getImageLibrary,
  getUuid,
  Log,
  parseMultilanguage,
  removeUtf8,
} from 'utils';

type ImageData = {
  base64: string;
  cancelled: boolean;
  height: number;
  uri: string; // data:image/png;base64,...
  width: number;
};

function Lbl(p: {
  content: string;
  marginTop?: number;
  reverse?: boolean;
  multilanguage?: boolean;
}) {
  if (p.reverse) {
    return (
      <Label size={14} marginTop={p.marginTop || 0} multilanguage={false}>
        {`(`}
        <Label size={14} multilanguage={false} color={Ecolors.red}>
          *
        </Label>
        {`) `}
        <Label size={14} multilanguage={false}>
          {p.content}
        </Label>
      </Label>
    );
  }
  return (
    <Label marginTop={p.marginTop || 0} multilanguage={false}>
      <Label>{p.content}</Label>
      {` (`}
      <Label multilanguage={false} color={Ecolors.red}>
        *
      </Label>
      {`)`}
    </Label>
  );
}

function EditBankInfoModal() {
  const dispatch = useAppDispatch();
  const route = useRoute<any>();
  const currentUser = useAppSelector(state => state.authen.currentUser);
  const isEdit = useAppSelector(state => getStatusEditBankInfo(state));

  const {bankAccount, bankAccountIsFull} = currentUser;
  const [name, setName] = useState('');
  const [bank, setBank] = useState<any>(null);
  const [branch, setBranch] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [number, setNumber] = useState('');
  const [annualIncome, setAnnualIncome] = useState<any>(null);
  const [incomeSource, setIncomeSource] = useState<any>(null);
  const [job, setJob] = useState<string>('');
  const [position, setPosition] = useState<string>('');
  const I18nState = useAppSelector(state => state.languages.I18nState);
  const bottomSheetUpload = useRef<any>(null);

  useEffect(() => {
    bindData(bankAccount, currentUser);
    return () => {};
  }, [bankAccount, currentUser]);

  const getDataBranch = async () => {
    const res = await doGetAxios(
      `bank/branch/list?bankId=${bankAccount?.bankId}`,
    );
    if (res.status == 200) {
      const t = res.data.find((a: any) => a.id == bankAccount?.branchId);
      if (t) {
        setBranch(t);
      }
    }
  };

  const hide = (cb?: () => void) => {
    if (bottomSheetUpload.current) {
      bottomSheetUpload.current.hide().then(() => {
        if (cb) {
          cb();
        }
      });
    }
  };

  const bindData = (
    e: {
      name?: string;
      number?: string;
      branchName?: string;
      branchName_en?: string;
      bankName?: string;
      bankName_en?: string;
      job?: string;
      position?: string;
      branchId?: string | number;
      bankId?: string | number;
    },
    currentUser: any,
  ) => {
    Promise.all([
      setName(
        removeUtf8(
          e?.name?.toLocaleUpperCase() ||
            currentUser?.name?.toLocaleUpperCase(),
        ),
      ),
      setNumber(e?.number || ''),
      getDataBranch(),
      setBank(
        e?.bankId
          ? {
              id: e.bankId || '1',
              name: e.bankName,
              nameEn: e.bankName_en,
            }
          : null,
      ),

      setAnnualIncome(
        stringApp.source.find(a => a.id == bankAccount?.incomeSource) || null,
      ),
      setIncomeSource(
        stringApp.monthlyIncom.find(a => a.id == bankAccount?.annualIncome) ||
          null,
      ),
      setJob(e?.job || ''),
      setPosition(e?.position || ''),
    ]);
  };

  const onConfirm = async (file?: any) => {
    try {
      if (!name.length || !number.length || !bank || !branch) {
        Alert.showError({
          content: `alert.vuilongnhapdayduthongtintaikhoannganhang`,
          onPress: () => {},
        });
        return;
      }
      let objAction = {
        bankId: `${bank?.id}` || '0',
        branchId: `${branch?.id || bank?.id}` || '0',
        name: name,
        number: number,
      };
      if (isEdit) {
        objAction[`position`] = position || '';
        objAction[`job`] = job || '';
        objAction[`incomeSource`] = incomeSource?.id || 'SOURCE_OTHER';
        objAction[`annualIncome`] = annualIncome?.id || '1';
      }

      if (route.params?.onConfirm) {
        route.params?.onConfirm({
          userBankAccount: {
            bankId: `${bank?.id}` || '0',
            branchId: `${branch?.id || bank?.id}` || '0',
            name: name,
            number: number,
          },
        });
        return;
      }
      setLoading(true);
      const res = await (!isEdit
        ? apiAuth.updateInvestmentBankTypeUpdate(file)
        : apiAuth.updateInvestmentBank(objAction));
      if (res.data?.otpInfo && !isEdit) {
        navigate('OtpRequestModal', {
          data: {
            requestOnSendOtp: res.data?.otpInfo,
            flowApp: 'UpdateBankInfo',
          },
          onConfirm: async () => {
            await dispatch(getInfo({}));
            Alert.show({
              type: 2,
              titleClose: 'alert.dong',
              content: `alert.capnhatthongtintaikhoannganhangthanhcong`,
              onConfirm: () => {
                goBack();
              },
              onClose: () => {
                goBack();
              },
              onCancel: () => {
                goBack();
              },
            });
            return;
          },
        });
        return;
      }
      if (res.status == 200) {
        await dispatch(getInfo({}));
        Alert.show({
          type: 2,
          titleClose: 'alert.dong',
          content: `alert.capnhattaikhoannganhang`,
          onConfirm: () => {
            goBack();
          },
          onClose: () => {
            goBack();
          },
          onCancel: () => {
            goBack();
          },
        });
        return;
      }
      Log('resresres', res);
      Alert.showError({
        content: I18nState == 'vi' ? res.message : res.messageEn,
        multilanguage: false,
        onPress: () => {
          goBack();
        },
      });
    } catch (error: any) {
      Log('errrr', error);
      Alert.showError({
        content: I18nState == 'vi' ? error.message : error.messageEn,
        multilanguage: false,
        onPress: () => {},
      });
      return;
    } finally {
      setLoading(false);
    }
  };

  const doAction = async (image: any, isFromGallery: boolean) => {
    if (!image) return;
    const base64Uri = isFromGallery ? image?.uri : image;
    const blob = await fetch(base64Uri).then(res => res.blob());

    const formdata = new FormData();
    const id = getUuid();
    formdata.append('file', blob, `${id}.png`);
    formdata.append('bankId', `${bank?.id}` || '0');
    formdata.append('branchId', `${branch?.id || bank?.id}` || '0');
    formdata.append('name', name || '');
    formdata.append('number', number || '');
    onConfirm(formdata);

    return;
  };

  return (
    <Div height={'100%'} backgroundColor={Ecolors.whiteColor}>
      <BottomSheetDialog
        style={{
          flexDirection: 'column',
          flex: 1,
          alignItems: 'center',
          justifyContent: 'flex-end',
        }}
        ref={bottomSheetUpload}>
        <ComActionUpload
          isDrawline={true}
          onDrawline={() => {
            hide(() => {
              navigate('SignatureDraw', {
                data: {
                  flowApp: 'EditBankInfo',
                },
                callback: (t: string) => {
                  doAction(t, false);
                },
              });
            });
          }}
          onCancel={() => {
            hide();
          }}
          onCamera={async () => {
            try {
              hide(async () => {
                await getImageCamera()
                  .then(async (image: any) => {
                    if (image[0]) {
                      await doAction(image[0], true);
                    }
                  })
                  .catch(() => {
                    hide();
                  });
              });
            } catch (error) {
              if (!!error) {
                Toast.show({
                  content: 'alert.daxayraloi',
                  multilanguage: true,
                });
              }
            } finally {
              hide(async () => {});
            }
          }}
          onGallery={async () => {
            try {
              hide(async () => {
                await getImageLibrary().then(async (image: any) => {
                  console.log('image', image[0]);
                  if (image[0]) {
                    if (image[0].uri.endsWith('.gif')) {
                      Alert.showError({
                        content: 'alert.dinhdanganhkhongphuhop',
                      });
                      return;
                    }
                    await doAction(image[0], true);
                  }
                });
              });
            } catch (error) {
              if (!!error) {
                Toast.show({
                  content: 'alert.daxayraloi',
                  multilanguage: true,
                });
                return;
              }
            } finally {
              hide(async () => {});
            }
          }}
        />
      </BottomSheetDialog>
      <HeaderBack
        type={2}
        loading={loading}
        titleRight={`accountverify.save`}
        onRightPress={() => {
          if (isEdit) {
            onConfirm();
            return;
          }
          bottomSheetUpload.current.show();
          return;
        }}
        title={`accountverify.thongtinnganhang`}
      />
      <ScrollView keyboardShouldPersistTaps={'never'}>
        <Div paddingHorizontal={29}>
          <Lbl
            marginTop={23}
            content={`accountverify.thongtintaikhoannganhang`}
          />
          <Lbl marginTop={7} content={`accountverify.tenchutaikhoan`} />
          <InputItem
            isInput={false}
            marginTop={6}
            keyboardType={'name-phone-pad'}
            onChangeText={e => setName(removeUtf8(e.toLocaleUpperCase()))}
            value={name}
            marginHorizontal={0}
          />
          <Lbl marginTop={13} content={`accountverify.sotaikhoan`} />
          <InputItem
            keyboardType={'number-pad'}
            value={number}
            onChangeText={a => checkToSetNumber(a, r => setNumber(r))}
            marginHorizontal={0}
            marginTop={6}
          />
          <Lbl marginTop={13} content={`accountverify.tennganhang`} />
          <Dropdown
            multilanguage={true}
            url={'bank/list'}
            isActive={true}
            value={bank}
            marginTop={6}
            paddingHorizontal={0}
            content={`accountverify.vuilongchonnganhang`}
            onChange={a => {
              setBank(a);
              setBranch(null);
            }}
          />
          <Lbl marginTop={13} content={`accountverify.chinhanh`} />
          <Dropdown
            multilanguage={true}
            isActive={!!bank}
            content={`accountverify.vuilongchonchinhanh`}
            url={`bank/branch/list?bankId=${bank?.id || 0}`}
            marginTop={6}
            value={branch}
            paddingHorizontal={0}
            onChange={a => setBranch(a)}
          />
          {isEdit && (
            <>
              <Lbl marginTop={23} content={`accountverify.thongtinkhac`} />
              <Lbl marginTop={7} content={`accountverify.nghenghiep`} />
              <InputItem
                // keyboardType={'number-pad'}
                value={job}
                onChangeText={a => setJob(a)}
                marginHorizontal={0}
                marginTop={6}
              />
              <Lbl marginTop={13} content={`accountverify.chucvu`} />
              <InputItem
                // keyboardType={'number-pad'}
                value={position}
                onChangeText={a => setPosition(a)}
                marginHorizontal={0}
                marginTop={6}
              />
              {/* <Lbl
                marginTop={13}
                content={`accountverify.mucthunhaphangthang`}
              />
              <Dropdown
                multilanguage={true}
                isActive={true}
                content={`accountverify.mucthunhaphangthang`}
                // url={`bank/branch/list?bankId=${bank?.id || 0}`}
                initData={stringApp.monthlyIncom || []}
                marginTop={6}
                value={annualIncome}
                paddingHorizontal={0}
                onChange={a => setAnnualIncome(a)}
              /> */}
              {/* <Lbl marginTop={13} content={`accountverify.nguontiendautu`} />
              <Dropdown
                multilanguage={true}
                isActive={true}
                content={`accountverify.nguontiendautu`}
                initData={stringApp.source || []}
                marginTop={6}
                value={incomeSource}
                paddingHorizontal={0}
                onChange={a => setIncomeSource(a)}
              /> */}
            </>
          )}
          <Lbl
            reverse={true}
            multilanguage={false}
            marginTop={20}
            content={parseMultilanguage('accountverify.editbankcontent')}
          />
        </Div>

        <Div height={300} />
      </ScrollView>
    </Div>
  );
}

export default React.memo(EditBankInfoModal);
